import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../../app/store';
import { createSelector } from 'reselect'
import { loadState } from "../../app/localStorage";

interface CounterState {
  value: number;
  addingAsync: boolean;
}

export const defaultState = {
  value: 0,
  addingAsync: false,
};

const initialState: CounterState = loadState()?.counter || defaultState;

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    // Use the PayloadAction type to declare the contents of `action.payload`
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.value += action.payload;
      state.addingAsync = false;
    },
    setAddingAsync: (state, action: PayloadAction<boolean>) => {
      state.addingAsync = action.payload;
    },
  },
});

export const { increment, decrement, incrementByAmount, setAddingAsync } = counterSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const incrementAsync = (amount: number): AppThunk => dispatch => {
  dispatch(setAddingAsync(true));
  setTimeout(() => {
    dispatch(incrementByAmount(amount));
  }, 1000);
};

// region --------------------------------------------------------------------------------- Selectors
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectCounterValue = (state: RootState) => state.counter.value;

export const selectCounterState = (state: RootState) => state.counter;

// With reselect you can compute derived data, allowing Redux to store the minimal possible state.
export const reselectDouble = createSelector(
  selectCounterValue,
  value => 2*value
);
// endregion

export default counterSlice.reducer;
